import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { Path as StyledPath } from './styles';

const Path = memo(({ type, d, color, gradientId }) => {
  return <StyledPath type={type} d={d} color={color} gradientId={gradientId} />;
});

Path.propTypes = {
  type: PropTypes.oneOf(['area', 'line']),
  d: PropTypes.string.isRequired,
  color: PropTypes.string,
  gradientId: PropTypes.string,
};

Path.defaultProps = {
  type: 'line',
  color: null,
  gradientId: null,
};

export default Path;
